// Core
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

// Register components in ChartJS
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const BarChartComponent = ({ chartData }) => {
  // Accept width and height as props
  const data = {
    labels: chartData?.labels,
    datasets: [
      {
        label: chartData?.datasets?.[0]?.label,
        data: chartData?.datasets?.[0]?.data,
        backgroundColor: "#83CBCC",
        borderRadius: 4,
        barPercentage: 0.4,
        categoryPercentage: 0.7,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "No. of Days",
          color: "#000000",
        },
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        max: 40,
        border: {
          display: false,
          dash: [4, 4],
          dashOffset: 3,
        },
        title: {
          display: true,
          text: "No. of Backlogs",
          color: "#000000",
        },
        ticks: {
          stepSize: 10,
        },
        grid: {
          tickBorderDash: [6, 2],
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default BarChartComponent;
